<template lang=""> 
    
        <v-container>
            <v-container>
                <v-row>
                    <v-container fluid fill-height>
                        <v-card width="100vw">
                            <v-row class="blue-grey lighten-5">
                                <v-col md="10"> <v-icon>mdi-thermometer</v-icon> SP Temperatura Max. Colector Ciclo Secado</v-col>
                                <v-col md="2">
                                    <hmi-editable-number-input 
                                        :valor="tempMaxColectorSecado" 
                                        topic="SP_Max_Auto_Colector"
                                        unidades="ºC"
                                        @cambio="escribir"
                                    />
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-container>
                </v-row>
                <v-row>
                    <v-container fluid fill-height>
                        <!-- <v-card width="100vw"> -->
                            <v-row>
                                <v-col md="10"> <v-icon>mdi-thermometer</v-icon> SP Temperatura Tromel Ciclo Secado:</v-col>
                                <v-col md="2">
                                    <hmi-editable-number-input 
                                        :valor="SpSecadoAutoTromel" 
                                        topic="SpSecadoAutoTromel"
                                        unidades="ºC"
                                        @cambio="escribir"
                                    />
                                </v-col>
                            </v-row>
                        <!-- </v-card> -->
                    </v-container>
                </v-row>
                <v-row>
                    <v-container fluid fill-height class="blue-grey lighten-5">
                        <!-- <v-card width="100vw"> -->
                            <v-row>
                                <v-col md="10"> <v-icon>mdi-thermometer</v-icon> SP Temperatura Tromel Ciclo 1 Higienización:</v-col>
                                <v-col md="2">
                                    <hmi-editable-number-input 
                                        :valor="SpEsterilizadoAutoTromel" 
                                        topic="SpEsterilizadoAutoTromel"
                                        unidades="ºC"
                                        @cambio="escribir"
                                    />
                                </v-col>
                            </v-row>
                        <!-- </v-card> -->
                    </v-container>
                </v-row>
                <v-row>
                    <v-container fluid fill-height>
                        <!-- <v-card width="100vw"> -->
                            <v-row>
                                <v-col md="10"> <v-icon>mdi-thermometer</v-icon> SP Temperatura Tromel Ciclo 2 Higienización:</v-col>
                                <v-col md="2">
                                    <hmi-editable-number-input 
                                        :valor="SpEsterilizadoAutoTromel2" 
                                        topic="SpEsterilizadoAutoTromel2"
                                        unidades="ºC"
                                        @cambio="escribir"
                                    />
                                </v-col>
                            </v-row>
                        <!-- </v-card> -->
                    </v-container>
                </v-row>
            </v-container>
            
            <v-container>
                <v-row
                no-gutters
                class="light-blue lighten-5"
                >
                <linea-tiempos titulo="Tiempo Máximo Ciclo Secado"
                    topic_hora="Time_horas_E4_ciclo_secado"
                    topic_minuto="Time_min_E4_ciclo_secado"
                    topic_segundo="Time_seg_E4_ciclo_secado"
                    :datos="datos"
                    topic_dec_hora="Dec_horas_E4_ciclo_secado"
                    topic_dec_minuto="Dec_min_E4_ciclo_secado"
                    topic_dec_segundo="Dec_seg_E4_ciclo_secado"
                    @cambio="escribir"
                />
                </v-row>

                <v-row
                no-gutters
                >
                <linea-tiempos titulo="Tiempo Máximo Ciclo 1 Higienización"
                    topic_hora="Time_horas_E5_ciclo_esterilizado"
                    topic_minuto="Time_min_E5_ciclo_esterilizado"
                    topic_segundo="Time_seg_E5_ciclo_esterilizado"
                    :datos="datos"
                    topic_dec_hora="Dec_horas_E5_ciclo_esterilizado"
                    topic_dec_minuto="Dec_min_E5_ciclo_esterilizado"
                    topic_dec_segundo="Dec_seg_E5_ciclo_esterilizado"
                    @cambio="escribir"
                />
                </v-row>

                <v-row
                no-gutters
                class="light-blue lighten-5"
                >
                <linea-tiempos titulo="Tiempo Máximo Ciclo 2 Higienización"
                    topic_hora="Time_horas_E5_Ciclo_Esterilizado2"
                    topic_minuto="Time_min_E5_Ciclo_Esterilizado2"
                    topic_segundo="Time_seg_E5_Ciclo_Esterilizado2"
                    :datos="datos"
                    topic_dec_hora="Dec_horas_E5_Ciclo_Esterilizado2"
                    topic_dec_minuto="Dec_min_E5_Ciclo_Esterilizado2"
                    topic_dec_segundo="Dec_seg_E5_Ciclo_Esterilizado2"
                    @cambio="escribir"
                />
                </v-row>

                <v-row
                no-gutters
                >
                <linea-tiempos titulo="Tiempo Máximo Descargar"
                    topic_hora="Time_horas_E9_Espera_Descarga"
                    topic_minuto="Time_min_E9_Espera_Descarga"
                    topic_segundo="Time_seg_E9_Espera_Descarga"
                    :datos="datos"
                    topic_dec_hora="Dec_horas_E9_Espera_Descarga"
                    topic_dec_minuto="Dec_min_E9_Espera_Descarga"
                    topic_dec_segundo="Dec_seg_E9_Espera_Descarga"
                    @cambio="escribir"
                />
                </v-row>

                <v-row
                no-gutters
                class="light-blue lighten-5"
                >
                <linea-tiempos titulo="Tiempo Máximo Soplante ciclo Enfriado 'o' Interrumpido"
                    topic_hora="Time_horas_EParo_Sec_con_Soplante"
                    topic_minuto="Time_min_EParo_Sec_con_Soplante"
                    topic_segundo="Time_seg_EParo_Sec_con_Soplante"
                    :datos="datos"
                    topic_dec_hora="Dec_horas_EParo_Sec_con_Soplante"
                    topic_dec_minuto="Dec_min_EParo_Sec_con_Soplante"
                    topic_dec_segundo="Dec_seg_EParo_Sec_con_Soplante"
                    @cambio="escribir"
                />
                </v-row>
            </v-container>
        </v-container>
    
</template>
<script>
import { mapActions, mapState } from 'vuex'
import HmiEditableNumberInput from '@/components/HMI/modulos/HmiEditableNumberInput.vue'
import LineaTiempos from '@/components/HMI/Tiempos/LineaTiempos.vue'
import ReferenciaVelocidad from "@/components/HMI/ReferenciasVelocidad/ReferenciaVelocidad.vue";

export default {

    components: {
        HmiEditableNumberInput, LineaTiempos, ReferenciaVelocidad
    },
    data() {
        return {
            datos: {}
        }
    },

    computed: {
        ...mapState('nodered',['client']),
        tempMaxColectorSecado() {
            if ('SP_Max_Auto_Colector' in this.datos) {
                return this.datos['SP_Max_Auto_Colector']
            } else {
                return '?'
            }
        },
        SpSecadoAutoTromel() {
            if ('Sp_Secado_Auto_Tromel' in this.datos) {
                return this.datos['Sp_Secado_Auto_Tromel']
            } else {
                return '?'
            }
        },
        SpEsterilizadoAutoTromel() {
            if ('SP_Esterilizado_Auto_Tromel' in this.datos) {
                return this.datos['SP_Esterilizado_Auto_Tromel']
            } else {
                return '?'
            }
        },SpEsterilizadoAutoTromel2() {
            if ('SP_Esterilizado_Auto_Tromel_2' in this.datos) {
                return this.datos['SP_Esterilizado_Auto_Tromel_2']
            } else {
                return '?'
            }
        },


    },

    methods: {
        ...mapActions('nodered',['doSubscribe', 'doPublish']),
        ...mapActions(['postData']),
        tratar_mensaje(mensaje) {
            if (mensaje.length > 0) this.datos = JSON.parse(mensaje);
        },
        //escribir en MQTT
        escribir(payload) {
            const publication = {
                topic: payload.topic,
                qos: 2,
                payload: JSON.stringify({ 'valor': payload.valor }),
            }
            this.guardarModificacionBBDD(payload.topic, payload.valor)
            this.doPublish(publication)
        },
        getValue(nombre) {
            if (nombre) {
                return this.datos[nombre]
            } else return '?'
        },
        async guardarModificacionBBDD(columna, valor){

            const item = {
                nombre_columna: columna,
                id_usuario: localStorage.getItem('id_usuario'),
                valor: valor,
            }

            // await this.axios.post(`/post-hmi-modificacion/`, item)
            const payload = {
                path: 'hmi/post-hmi-modificacion',
                body: item,
            }
            await this.postData(payload)
            .then(respuesta => {
                console.log('Valor HMI modificado correctamente');
            })
        },
    },

    created() {
        this.doSubscribe('REGULADORES1')
        this.client.on('message', (topic, message) => {
            // console.log("HA RECIBIDO UN MENSAJITO")
            //Datos relativos al ensayo (realizado por, lote MP, lote bolson, Cuerpos extraños,kg membrana y lote membrana)
            if (topic == "REGULADORES1") {
                this.tratar_mensaje(message)
            }
            //Limpiar datos de produccion

        })

    },


}
</script>
<style>
.amarillo {
    background-color: yellow;
}

.cyan {
    background-color: rgb(8, 216, 188);
}
</style>